import request from "../../../../Helpers/API";
import { extraerMensajeError } from "../../../../Helpers/ErrorHelper";

// Cliente HTTP de Indicadores de Cotizaciones. request.get (Helpers/API.js) ya agrega
// "Authorization: Bearer <token>" (localStorage) y maneja 401 de forma global (redirige a
// /auth/login), por eso aquí no se repite esa lógica.
export { extraerMensajeError };

export const IndicadoresCotizacionesCRMService = {
  // GET /ReporteCotizaciones — arreglo plano semana/vendedor/línea con objetivo mensual,
  // objetivo (semanal por línea), real y cumplimiento.
  reporteCotizaciones: (ejercicio, periodo) =>
    request.get(`IndicadoresCotizaciones/ReporteCotizaciones?ejercicio=${ejercicio}&periodo=${periodo}`),

  // GET /ImprimirExcelReporteCotizaciones — regresa { documento (base64), filename }, mismo
  // patrón que los demás reportes CRM.
  imprimirExcel: (ejercicio, periodo) =>
    request.get(`IndicadoresCotizaciones/ImprimirExcelReporteCotizaciones?ejercicio=${ejercicio}&periodo=${periodo}`),
};
